export default "__VITE_ASSET__vOv6x67c__"